/* Paw by Paw — theme behaviour
   Cart drawer, transparent home header, mobile nav, and the two
   personalisation builders (name collar + charm collar). */
(function () {
  'use strict';

  var R = (window.PBP && window.PBP.routes) || {};
  var FREE_SHIP = (window.PBP && window.PBP.freeShipThreshold) || 99900;

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function money(cents) {
    var v = cents / 100;
    var opts = v % 1 === 0 ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    try { return '₹' + v.toLocaleString('en-IN', opts); }
    catch (e) { return '₹' + v.toFixed(v % 1 === 0 ? 0 : 2); }
  }
  window.pbpMoney = money;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var tt;
  function toast(m) {
    var t = $('#toast'); if (!t) return;
    t.textContent = m; t.classList.add('on');
    clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('on'); }, 2100);
  }
  window.pbpToast = toast;

  function parsePairs(raw) {
    // "Marigold:#E8833A" per line -> [{n,h}]
    return String(raw || '').split('\n').map(function (line) {
      var p = line.split(':');
      if (p.length < 2) return null;
      var n = p[0].trim(), h = p.slice(1).join(':').trim();
      return n && h ? { n: n, h: h } : null;
    }).filter(Boolean);
  }
  window.pbpParsePairs = parsePairs;

  /* ---------- colour maths for the charm beads ---------- */
  function rgbOf(h) {
    h = h.replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    return [0, 2, 4].map(function (i) { return parseInt(h.substr(i, 2), 16) || 0; });
  }
  function mix(h, t, a) {
    var A = rgbOf(h), B = rgbOf(t);
    return '#' + A.map(function (v, i) {
      return Math.round(v + (B[i] - v) * a).toString(16).padStart(2, '0');
    }).join('');
  }
  function lum(h) { var c = rgbOf(h); return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255; }
  function beadInk(h) { return lum(h) < 0.42 ? mix(h, '#ffffff', 0.72) : mix(h, '#1A1618', 0.58); }
  function onWhite(h) { return lum(h) > 0.62 ? mix(h, '#1A1618', 0.45) : h; }

  /* ---------- header ---------- */
  function syncHeader() {
    var bar = $('.bar'), ann = $('#ann');
    var h = function (el) { return el && !el.hidden ? Math.ceil(el.getBoundingClientRect().height) : 0; };
    document.documentElement.style.setProperty('--topchrome', (h(bar) + h(ann)) + 'px');
    if (!document.body.classList.contains('home')) { document.body.classList.remove('scrolled'); return; }
    var fh = $('.fh');
    var limit = fh ? fh.offsetHeight - h(bar) - 8 : 40;
    document.body.classList.toggle('scrolled', window.scrollY > limit);
  }
  window.addEventListener('scroll', syncHeader, { passive: true });
  window.addEventListener('resize', syncHeader);

  /* ---------- cart drawer ---------- */
  var drawer, scrim;
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('on'); scrim.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('on'); scrim.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
  }
  window.pbpOpenCart = openCart;
  window.pbpCloseCart = closeCart;

  function lineProps(item) {
    var out = [];
    var props = item.properties || {};
    Object.keys(props).forEach(function (k) {
      if (k.charAt(0) === '_' || !props[k]) return;
      out.push('<div class="v">' + esc(k) + ': <b style="color:var(--ink)">' + esc(props[k]) + '</b></div>');
    });
    return out.join('');
  }

  function renderCart(cart) {
    var countEl = $('#cartcount');
    if (countEl) countEl.textContent = cart.item_count;

    var box = $('#cartitems'), foot = $('#cartfoot');
    if (!box || !foot) return;

    if (!cart.items.length) {
      box.innerHTML = '<div class="empty">' +
        (window.PBP.markUrl ? '<img src="' + window.PBP.markUrl + '" alt="">' : '') +
        '<p class="muted" style="font-size:.9rem">Nothing here yet.</p>' +
        '<a href="' + (window.PBP.shopAllUrl || '/collections/all') + '" class="ulink">Start shopping</a></div>';
      foot.innerHTML = '';
      return;
    }

    box.innerHTML = cart.items.map(function (item, i) {
      var opts = (item.options_with_values || []).filter(function (o) {
        return o.value && o.value.toLowerCase() !== 'default title';
      }).map(function (o) { return o.value; }).join(' · ');

      var img = item.image
        ? '<img class="tile-img" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x200_crop_center$1$2') + '" alt="">'
        : '<div class="tile-img"></div>';

      return '<div class="citem" data-line="' + (i + 1) + '">' +
        '<div class="pic">' + img + '</div>' +
        '<div><h4>' + esc(item.product_title) + '</h4>' +
        (opts ? '<div class="v">' + esc(opts) + '</div>' : '') +
        lineProps(item) +
        '<div class="ministep">' +
          '<button data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
          '<span class="num">' + item.quantity + '</span>' +
          '<button data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
        '</div>' +
        '<div><button class="rm" data-qty="0">Remove</button></div></div>' +
        '<div class="p num">' + money(item.final_line_price) + '</div></div>';
    }).join('');

    var sub = cart.total_price;
    var left = Math.max(0, FREE_SHIP - sub);
    foot.innerHTML =
      '<div class="ship"><p>' + (left > 0
        ? 'Add <b>' + money(left) + '</b> for free delivery'
        : 'Free delivery unlocked') + '</p>' +
      '<div class="track"><i style="width:' + Math.min(100, Math.round(sub / FREE_SHIP * 100)) + '%"></i></div></div>' +
      '<div class="totals">' +
        '<div><span>Subtotal</span><span class="num">' + money(sub) + '</span></div>' +
        '<div class="grand"><span>Total</span><span class="num">' + money(sub) + '</span></div>' +
      '</div>' +
      '<p class="muted" style="font-size:.72rem;text-align:center">Delivery and taxes calculated at checkout</p>' +
      '<a href="' + R.cart + '/checkout" class="btn block">Checkout</a>';
  }

  function refreshCart(open) {
    return fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); return cart; });
  }
  window.pbpRefreshCart = refreshCart;

  function changeLine(line, qty) {
    return fetch(R.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); });
  }

  function addToCart(payload) {
    return fetch(R.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    }).then(function () {
      return refreshCart(true).then(function () { toast('Added to cart'); });
    }).catch(function (err) { toast(err.message); throw err; });
  }
  window.pbpAddToCart = addToCart;

  /* ================= personalisation builders ================= */
  var modal, CB = { mode: null, root: null, items: [], colour: null, strap: null, cfg: null };

  function cfgFrom(root) {
    return {
      mode: root.dataset.personalise,                       // 'name' | 'charms'
      charmId: parseInt(root.dataset.charmId || '0', 10),   // the add-on product
      charmPrice: parseInt(root.dataset.charmPrice || '0', 10),
      straps: parsePairs(root.dataset.straps),
      colours: parsePairs(root.dataset.letterColours),
      glyphs: (root.dataset.glyphs || '').split(',').map(function (g) { return g.trim(); }).filter(Boolean),
      max: parseInt(root.dataset.max || '10', 10),
      min: parseInt(root.dataset.min || '1', 10),
      title: root.dataset.title || 'Personalise'
    };
  }

  // charms are priced per piece, so the total is simply count x unit price
  function charmTotal(cfg, n) { return cfg.charmPrice * n; }

  // whichever collar variant the shopper has selected on the page
  function pageVariant() {
    var el = document.getElementById('pdpvariant');
    return el ? parseInt(el.value, 10) : 0;
  }
  function pageColour() {
    var row = null;
    $$('.opts').forEach(function (r) {
      var n = (r.dataset.optionName || '').toLowerCase();
      if (n === 'colour' || n === 'color') row = r;
    });
    if (!row) return null;
    var on = row.querySelector('.opt.on');
    return on ? on.dataset.value : null;
  }

  function openBuilder(root) {
    var cfg = cfgFrom(root);
    if (!cfg.charmId) { toast('Personalisation is not set up yet'); return; }
    CB = { mode: cfg.mode, root: root, items: [], colour: (cfg.colours[0] || {}).n, strap: (cfg.straps[0] || {}).n, cfg: cfg };
    var pre = pageColour() || root.dataset.selectedColour;
    if (pre) for (var i = 0; i < cfg.straps.length; i++) if (cfg.straps[i].n === pre) CB.strap = pre;
    $('#cmodal-title').textContent = cfg.title;
    draw();
    modal.classList.add('on');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeBuilder() {
    modal.classList.remove('on');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function hexOf(list, n) {
    for (var i = 0; i < list.length; i++) if (list[i].n === n) return list[i].h;
    return (list[0] || {}).h || '#cccccc';
  }

  function draw() {
    var cfg = CB.cfg, n = CB.items.length, full = n >= cfg.max;
    var strapHex = hexOf(cfg.straps, CB.strap);

    var strapInner = n
      ? CB.items.map(function (it, i) {
          var h = hexOf(cfg.colours, it.colour);
          return '<span class="chip"><b style="background:' + h + ';color:' + beadInk(h) + '">' + esc(it.ch) + '</b>' +
                 '<button class="x" data-remove="' + i + '" aria-label="Remove ' + esc(it.ch) + '">&times;</button></span>';
        }).join('')
      : '<span class="ph">' + (CB.mode === 'charms' ? 'Tap a charm below to start' : 'Type a name below') + '</span>';

    var nameField = CB.mode === 'name'
      ? '<div><div class="lbl" style="margin-bottom:10px">Their name</div>' +
        '<div class="nameinput"><input id="cname" type="text" maxlength="' + cfg.max + '" ' +
        'value="' + esc(CB.items.map(function (i) { return i.ch; }).join('')) + '" ' +
        'placeholder="MOCHI" autocomplete="off" spellcheck="false" aria-label="Their name">' +
        '<span class="count num">' + n + '/' + cfg.max + '</span></div>' +
        '<p class="hint muted" style="margin-top:8px;font-size:.78rem">Letters A–Z only, ' + cfg.min + ' to ' + cfg.max + '.</p></div>'
      : '';

    var glyphGrid = CB.mode === 'charms'
      ? '<div><div class="lbl" style="margin-bottom:10px">Add charms</div>' +
        '<div class="glyphs" id="cglyphs">' + cfg.glyphs.map(function (g) {
          return '<button type="button" data-g="' + esc(g) + '"' + (full ? ' disabled' : '') +
                 ' style="color:' + onWhite(hexOf(cfg.colours, CB.colour)) + '">' + esc(g) + '</button>';
        }).join('') + '</div></div>'
      : '';

    $('#cbody').innerHTML =
      '' +
      '<div><div class="cstrap" id="cstrap" style="background:' + strapHex + '">' + strapInner + '</div>' +
        '<div class="cmeta" style="padding-top:10px">' +
          '<span class="lbl faint num">' + n + ' / ' + cfg.max + ' ' + (CB.mode === 'charms' ? 'charms' : 'letters') + '</span>' +
          (n ? '<button type="button" class="clear" id="cclear">Clear all</button>' : '') +
        '</div></div>' +
      nameField +
      '<div class="crow"><span class="lbl">' + (CB.mode === 'charms' ? 'Charm colour' : 'Letter colour') + '</span>' +
        '<div class="pills" id="ccol">' + cfg.colours.map(function (c) {
          return '<button type="button" class="pill ' + (c.n === CB.colour ? 'on' : '') + '" data-v="' + esc(c.n) + '">' +
                 '<i style="background:' + c.h + '"></i>' + esc(c.n) + '</button>';
        }).join('') + '</div></div>' +
      glyphGrid;

    var btn = $('#pmodal-add');
    var ok = n >= cfg.min;
    btn.disabled = !ok;
    if (!n) {
      btn.textContent = CB.mode === 'charms' ? 'Add a charm to begin' : 'Type a name to begin';
    } else if (n < cfg.min) {
      btn.textContent = 'At least ' + cfg.min + (CB.mode === 'charms' ? ' charm' : ' letter') + (cfg.min > 1 ? 's' : '');
    } else {
      btn.innerHTML = 'Add to cart — ' + money(charmTotal(cfg, n)) +
        ' <span style="opacity:.65;font-weight:400">· ' + n + ' ' + (CB.mode === 'charms' ? 'charms' : 'letters') +
        ' at ' + money(cfg.charmPrice) + ' each</span>';
    }
    bind();
  }

  function bind() {
    var cfg = CB.cfg;

    $$('#cstrapc button').forEach(function (b) {
      b.onclick = function () { CB.strap = b.dataset.v; draw(); };
    });
    $$('#ccol button').forEach(function (b) {
      b.onclick = function () {
        CB.colour = b.dataset.v;
        if (CB.mode === 'name') CB.items = CB.items.map(function (i) { return { ch: i.ch, colour: CB.colour }; });
        draw();
      };
    });
    $$('#cglyphs button').forEach(function (b) {
      b.onclick = function () {
        if (CB.items.length >= cfg.max) { toast(cfg.max + ' charms is the limit'); return; }
        CB.items.push({ ch: b.dataset.g, colour: CB.colour });
        draw();
      };
    });
    $$('#cstrap .x').forEach(function (b) {
      b.onclick = function () { CB.items.splice(parseInt(b.dataset.remove, 10), 1); draw(); };
    });
    var cl = $('#cclear');
    if (cl) cl.onclick = function () { CB.items = []; draw(); };

    var input = $('#cname');
    if (input) {
      input.oninput = function () {
        var v = input.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, cfg.max);
        input.value = v;
        CB.items = v.split('').map(function (ch) { return { ch: ch, colour: CB.colour }; });
        var pos = input.selectionStart;
        drawPreviewOnly();
        var again = $('#cname');
        if (again) { again.focus(); try { again.setSelectionRange(pos, pos); } catch (e) {} }
      };
    }
  }

  // redraw without destroying the focused input
  function drawPreviewOnly() {
    var cfg = CB.cfg, n = CB.items.length;
    var strap = $('#cstrap');
    if (strap) {
      strap.innerHTML = n
        ? CB.items.map(function (it, i) {
            var h = hexOf(cfg.colours, it.colour);
            return '<span class="chip"><b style="background:' + h + ';color:' + beadInk(h) + '">' + esc(it.ch) + '</b>' +
                   '<button class="x" data-remove="' + i + '" aria-label="Remove">&times;</button></span>';
          }).join('')
        : '<span class="ph">Type a name below</span>';
    }
    var meta = $('.cmeta .lbl');
    if (meta) meta.textContent = n + ' / ' + cfg.max + ' letters';
    var cnt = $('#cname + .count, .nameinput .count');
    if (cnt) cnt.textContent = n + '/' + cfg.max;

    var btn = $('#pmodal-add');
    var ok = n >= cfg.min;
    btn.disabled = !ok;
    btn.innerHTML = ok
      ? 'Add to cart — ' + money(charmTotal(cfg, n)) +
        ' <span style="opacity:.65;font-weight:400">· ' + n + ' letters at ' + money(cfg.charmPrice) + ' each</span>'
      : (n === 0 ? 'Type a name to begin' : 'At least ' + cfg.min + ' letters');

    $$('#cstrap .x').forEach(function (b) {
      b.onclick = function () {
        CB.items.splice(parseInt(b.dataset.remove, 10), 1);
        var f = $('#cname'); if (f) f.value = CB.items.map(function (i) { return i.ch; }).join('');
        drawPreviewOnly();
      };
    });
  }

  function submitBuilder() {
    var cfg = CB.cfg, n = CB.items.length;
    if (n < cfg.min || !cfg.charmId) return;

    var collarId = pageVariant();
    var label = CB.items.map(function (i) { return i.ch; }).join('');
    var colours = CB.items.map(function (i) { return i.colour; });
    var uniq = colours.filter(function (c, i) { return colours.indexOf(c) === i; }).join(', ');

    // properties go on the charm line, and a short note on the collar line so
    // the two read as one thing in the cart and on the packing slip
    var props = {};
    if (CB.mode === 'charms') {
      props['Charms'] = CB.items.map(function (i) { return i.ch; }).join(' ');
      props['Charm colours'] = uniq;
      props['_charm_detail'] = CB.items.map(function (i) { return i.ch + ':' + i.colour; }).join('|');
    } else {
      props['Spells'] = label;
      props['Letter colour'] = uniq;
      props['_charm_detail'] = CB.items.map(function (i) { return i.ch + ':' + i.colour; }).join('|');
    }
    props['For'] = document.querySelector('.pdp .side h1')
      ? document.querySelector('.pdp .side h1').textContent.trim() : '';

    var items = [];
    if (collarId) {
      items.push({ id: collarId, quantity: 1,
        properties: { 'Personalised': CB.mode === 'charms' ? (n + ' charms') : label } });
    }
    items.push({ id: cfg.charmId, quantity: n, properties: props });

    var btn = $('#pmodal-add');
    btn.disabled = true;
    addToCart({ items: items })
      .then(function () { closeBuilder(); })
      .catch(function () { btn.disabled = false; });
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    drawer = $('#drawer'); scrim = $('#scrim'); modal = $('#cmodal');

    var cartBtn = $('#cartbtn');
    if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); });
    var close = $('#closecart'); if (close) close.onclick = closeCart;
    if (scrim) scrim.onclick = closeCart;

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (modal && modal.classList.contains('on')) closeBuilder(); else closeCart();
    });

    // cart line controls (delegated)
    var items = $('#cartitems');
    if (items) items.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]'); if (!b) return;
      var row = b.closest('[data-line]'); if (!row) return;
      changeLine(parseInt(row.dataset.line, 10), parseInt(b.dataset.qty, 10));
    });

    // mobile nav
    var menu = $('#nav'), menubtn = $('#menubtn');
    if (menu && menubtn) menubtn.onclick = function () {
      menubtn.setAttribute('aria-expanded', String(menu.classList.toggle('open')));
    };

    // announcement dismiss
    var annClose = $('[data-ann-close]');
    if (annClose) annClose.onclick = function () { $('#ann').hidden = true; syncHeader(); };

    // personalisation entry points
    $$('[data-personalise]').forEach(function (root) {
      $$('[data-open-personalise]', root).forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); openBuilder(root); });
      });
    });
    var mclose = $('#cclose'); if (mclose) mclose.onclick = closeBuilder;
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeBuilder(); });
    var madd = $('#pmodal-add'); if (madd) madd.onclick = submitBuilder;

    // any plain add-to-cart form on the page
    $$('form.pbp-add-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        var payload = { items: [{ id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) }] };
        var btn = form.querySelector('[type=submit]');
        if (btn) btn.disabled = true;
        addToCart(payload).then(function () { if (btn) btn.disabled = false; })
                          .catch(function () { if (btn) btn.disabled = false; });
      });
    });

    // lift sticky behaviour onto the Shopify section wrapper that sits in <body>
    var hdr = $('header.site');
    if (hdr) {
      var node = hdr;
      while (node.parentNode && node.parentNode !== document.body) node = node.parentNode;
      if (node !== hdr) node.classList.add('pbp-sticky');
    }

    syncHeader();
    refreshCart(false);
  });
})();
